import React from 'react'
import { Pagination } from '../Pagination'
import type { DataTablePaginationProps } from './DataTable.types'

const DataTablePagination: React.FC<DataTablePaginationProps> = (props) => (
  <Pagination {...props} />
)

export default DataTablePagination
